module.exports = __webpack_public_path__ + "assets/img/gal_11.38d1e6ba.jpg";